<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>注册费</span>
      </div>

      <div class="table">
        <div class="list">
          <div class="list-left">国内</div>
          <div class="list-right1">
            <div class="p">在职人员：2300元/人
              <br><br>普通在校研究生：1200元/人
            </div>
            <div class="p"></div>
          </div>
          <div class="img">
            <img src="../assets/erweima.jpg" width="150px">
            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请用微信扫码
          </div>
        </div>
        <div class="list no-border">
          <div class="list-left">国际</div>
          <div class="list-right">
            <div class="p">
              在职人员：495美元/人
            </div>
            <div class="p no-border">普通在校研究生：225美元/人</div>
          </div>
        </div>
      </div>

      <div class="table">
        <div class="list no-border">
          <div class="list-right">
            <div class="p-title">银行账户信息: </div>
            <div class="p">公司名称：江苏承学文化礼仪服务有限公司</div>
            <div class="p">纳税人识别号：91320211MA229X4311</div>
            <div class="p">地 址：无锡市梁溪区恒隆广场写字楼2座10F</div>
            <div class="p">开 户 行：中国建设银行股份有限公司无锡蠡湖支行</div>
            <div class="p">账 号：32050161894100001988</div>
            <div class="p">银行代码: 105302000460 </div>
            <div class="p">联系电话：13915265682</div>
          </div>
        </div>
      </div>

      <div class="table">
        <div class="title" style="padding: 15px;">
          <b>缴费方式</b>
        </div>
        <div class="listpic">
          <div>
            <p>
              1. 手机端支付（内含开票信息和房间预订）
            </p>
            <img class="pic" src="../assets/pic-1.png" alt="" />
          </div>
          <div>
            2. 现场支付
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  methods: {},
};
</script>

<style scoped lang="less">
.index-con {
  margin: 0 auto;
  width: 1200px;
}

.email {
  color: rgb(30, 98, 222);
  font-weight: 600;
}

.table {
  width: 800px;
  margin: 30px auto;
  border: 1px solid #28d6ec;

  .list {
    display: flex;
    box-sizing: border-box;
    border-bottom: 1px solid #28d6ec;
  }

  .img {
    width: 150px;
    margin: 30px 150px 50px 30px;
  }

  .listpic {
    display: flex;
    box-sizing: border-box;
    border-bottom: 1px solid #28d6ec;
    justify-content: center;
    padding: 5px;

    div {
      text-align: center;
      padding: 0 10px;
    }
  }

  .list-left {
    width: 80px;
    border-right: 1px solid #28d6ec;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
  }

  .pic {
    width: 220px;
    height: 330px;
    height: auto;
    align-items: center;
    justify-content: center;
  }

  .list-right {
    flex: 1;
  }

  .list-right1 {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .p {

    height: 40px;
    display: flex;
    align-items: center;
    justify-content: left;
    box-sizing: border-box;
    margin-left: 30px;
  }

  .p-title {
    flex: 1;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: left;
    box-sizing: border-box;
    margin-left: 30px;
    font-weight: 700;
  }

  .no-border {
    border: 0;
  }
}

.en {
  .list {
    display: flex;
    height: 40px;
  }

  .list:nth-of-type(1) {
    font-weight: 600;
  }

  p {
    width: 50%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  p:nth-of-type(1) {
    border-right: 1px solid #28d6ec;
  }
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/here.vue